var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0a5078",
    d: "M16 32h24v28H16z",
    opacity: 1,
    "data-original": "#0a5078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a5078",
    d: "M28 51a8 8 0 0 1-8-8V32h16v11a8 8 0 0 1-8 8z",
    opacity: 1,
    "data-original": "#0a5078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00325a",
    d: "M17 60V42.5a.5.5 0 0 0-1 0V60zM40 60V42.5a.5.5 0 0 0-1 0V60z",
    opacity: 1,
    "data-original": "#00325a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a5078",
    d: "M8 40v20h8V32a8 8 0 0 0-8 8zM40 32v28h8V40a8 8 0 0 0-8-8z",
    opacity: 1,
    "data-original": "#0a5078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M28 51a4 4 0 0 1-4-4V32h8v15a4 4 0 0 1-4 4z",
    opacity: 1,
    "data-original": "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2d2d2",
    d: "m24 41 4-4 4 4v-8h-8z",
    opacity: 1,
    "data-original": "#d2d2d2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c80a50",
    d: "M30 32h-4v18.465c.588.34 1.271.535 2 .535s1.412-.195 2-.535z",
    opacity: 1,
    "data-original": "#c80a50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a00028",
    d: "m26 39 2-2 2 2v-6h-4z",
    opacity: 1,
    "data-original": "#a00028"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "m28 36 4 4v-8h-8v8z",
    opacity: 1,
    "data-original": "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a5078",
    d: "M32 6h-8a6 6 0 0 0-6 6v6h20v-6a6 6 0 0 0-6-6z",
    opacity: 1,
    "data-original": "#0a5078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2aa82",
    d: "m32 32-4 4-4-4v-6h8z",
    opacity: 1,
    "data-original": "#d2aa82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0c8a0",
    d: "M30 30h-4a8 8 0 0 1-8-8v-4a2 2 0 0 0 2-2v-4h16v4a2 2 0 0 0 2 2v4a8 8 0 0 1-8 8z",
    opacity: 1,
    "data-original": "#f0c8a0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d2aa82",
    d: "M18 22v-6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2zM38 22v-6a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2z",
    opacity: 1,
    "data-original": "#d2aa82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0a5078",
    d: "M34 12H20V8a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8z",
    opacity: 1,
    "data-original": "#0a5078"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00325a",
    d: "M40 32h-4.724A13.947 13.947 0 0 0 32 41c0 7.732 6.268 14 14 14 .679 0 1.347-.049 2-.142V40a8 8 0 0 0-8-8z",
    opacity: 1,
    "data-original": "#00325a"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 40,
    r: 14,
    fill: "#00a0c8",
    opacity: 1,
    "data-original": "#00a0c8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0082aa",
    d: "M52 49H40a2 2 0 0 1-2-2V35a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2z",
    opacity: 1,
    "data-original": "#0082aa"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fab400",
    d: "M52 48H40a2 2 0 0 1-2-2V34a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2z",
    opacity: 1,
    "data-original": "#fab400"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be7800",
    d: "M47 34h-2a1 1 0 0 1-1-1v-1h4v1a1 1 0 0 1-1 1z",
    opacity: 1,
    "data-original": "#be7800"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dc9600",
    d: "m46.448 36.078 1.265 2.564 2.829.411a.5.5 0 0 1 .277.853l-2.047 1.996.483 2.818a.5.5 0 0 1-.725.527L46 43.915l-2.531 1.33a.5.5 0 0 1-.725-.527l.483-2.818-2.047-1.996a.5.5 0 0 1 .277-.853l2.829-.411 1.265-2.564a.5.5 0 0 1 .897.002z",
    opacity: 1,
    "data-original": "#dc9600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.3afa9a0258a030e42d5a5f51d9eef1b3.svg";
export { ForwardRef as ReactComponent };